import React, { useContext, useRef } from 'react';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import PbxContext from '../../context/PbxContext';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

const ChartCallsStatusByTime = ({ getRows }) => {
  const getItensStateGlobal = useContext(PbxContext);
  const { storageDataReport, dataForRequestCalls } = getItensStateGlobal;

  const { receivedsHours } = storageDataReport;

  const labels = Object.keys(receivedsHours);

  const chartCallsHorsReceivedsRef = useRef(null);

  const getDataToRequestFilter = (event) => {
    const { dateStart, dateStop } = dataForRequestCalls;
    const date1 = new Date(dateStart); 
    const date2 = new Date(dateStop); 

    const year1 = date1.getFullYear();
    const day1 = date1.getUTCDay();
    
    const year2 = date2.getFullYear();
    const day2 = date2.getUTCDay();

    if (year1 !== year2) return;
    if (day1 !== day2) return;
    
    if (chartCallsHorsReceivedsRef.current) {
    const chart = ChartJS.getChart(chartCallsHorsReceivedsRef.current);
    const clickedElements = chart.getElementsAtEventForMode(event, 'nearest',{ intersect: true }, true);
    if (clickedElements.length > 0) {
      const firstElement = clickedElements[0];
      let labelType = chart.data.datasets[firstElement.datasetIndex].label;
      const labelIndexClicked = chart.data.labels[firstElement.index];

      labelType === 'Não Atendidas' ? labelType = 'perdida' : labelType = 'atendida';

      getRows('receiveds-hours', labelIndexClicked, labelType);
    }
   }
  };

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
      },
    },
  };

  const data = {
    labels,
    datasets: [
      {
        label: 'Atendidas',
        data: labels.map((label) => receivedsHours[label].atendidas),
        fill: true,
        backgroundColor: "rgba(53, 162, 235,0.2)",
        borderColor: "rgba(30, 144, 255, 0.7)",
        datalabels: {
          align: 'top',
          display: true,//function(context) {
          //   return context.dataIndex % 2; // display labels with an odd index
          // },
        },
      },
      {
        label: 'Não Atendidas',
        data: labels.map((label) => receivedsHours[label].perdidas),
        fill: false,
        borderColor: "rgba(255, 99, 132, 0.7)",
        datalabels: {
          align: 'top',
          display: true, // function(context) {
          //   return context.dataIndex % 2; // display labels with an odd index
          // },
        },
      }
    ]
  };

  return (
    <div className="column is-half">
      <h2 className="has-text-centered is-size-5">Chamadas Recebidas por Hora</h2>
        <Line options={options} data={data} plugins={[ChartDataLabels]} ref={chartCallsHorsReceivedsRef} getElementAtEvent={(_, event) => getDataToRequestFilter(event)} />
    </div>
  );
}

export default ChartCallsStatusByTime;
